import { Directive } from '@angular/core';
import { ShowOnEnterDirective } from './show-on-enter.directive';

@Directive({
  selector: '[showup]',
  standalone: true,
})
export class ShowupDirective extends ShowOnEnterDirective {
  protected override readonly direction = 'up';
}
